module.exports = __webpack_public_path__ + "img/banner-8.4d8cd617.jpg";